import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserHowToPlaySceneDemo from 'src/games/demos/howToPlayScene/Main';

interface HowToPlaySceneDemoProps extends PageProps<{}> {
}

class HowToPlaySceneDemo extends React.Component<HowToPlaySceneDemoProps> {
    private game: Phaser.Game;
    constructor(props: HowToPlaySceneDemoProps) {
        super(props);
        bindAllOfThis(this, HowToPlaySceneDemo.prototype);
    }

    render() {
        return (<div>
            <PhaserHowToPlaySceneDemo />
        </div>);
    }
}

export default HowToPlaySceneDemo;



// WEBPACK FOOTER //
// ./src/pages/game/demos/HowToPlaySceneDemo.tsx